<template>
  <el-form
    class="change-phone form-container"
    ref="form"
    :model="form"
    label-width="0px"
    :rules="rules"
  >
    <el-form-item  prop="phone">
      <el-input type="passwords" v-model="form.phone">
        <template slot="prepend">+86</template>
      </el-input>
    </el-form-item>
    <el-form-item prop="smsCode">
      <el-input placeholder="请输入短信验证码" v-model="form.smsCode">
          <el-button slot='append' @click="requestSmsCode" :disabled="smsLimit?'disabled':false">
            {{smsLimit>0?`${smsLimit}s`:"短信验证码"}}</el-button>
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit" size="small">绑定</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import { getSmsCode, modifyPersonalInfo } from '@/api/personal-center/setting';

export default {
  name: 'change-phone',
  data() {
    const validatePhone = (rule, value, callback) => {
      if (/^1[3-9]\d{9}$/.test(value)) {
        callback();
        return;
      }
      callback(new Error('请输入正确的手机号码'));
    };
    return {
      smsLimit: 0,
      form: {
      },
      rules: {
        phone: [{
          required: true,
          message: '请输入新手机号',
          trigger: 'blur',
        }, {
          validator: validatePhone,
          trigger: 'blur',
        }],
        smsCode: [{
          required: true,
          message: '请输入短信验证码',
          trigger: 'blur',
        }, {
          min: 4,
          max: 6,
          message: '长度在4~6个字符',
          trigger: 'blur',
        }],
      },
    };
  },
  computed: {
    accountId() {
      return this.$store.getters.accountId;
    },
  },
  methods: {
    onSubmit() {
      this.modifyPhone();
    },
    modifyPhone() {
      modifyPersonalInfo({}, {
        UIDstr: this.accountId,
        MobilePhone: this.form.phone,
        VerificationCode: this.form.smsCode,
      }).then(() => {
        this.$message({
          message: '修改手机号成功',
          type: 'success',
        });
        setTimeout(() => {
          this.$emit('changeResult', 1);
        }, 2000);
      });
    },
    requestSmsCode() {
      console.log('更换手机号');
      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'warning',
        });
        return;
      }
      getSmsCode({
        UIDstr: this.accountId,
        PhoneNumber: this.form.phone,
      }).then(() => {
        this.$message({
          message: '短信验证码已发送，请注意查收',
          type: 'success',
        });
        this.resetCountDown();
      });
    },
    resetCountDown() {
      this.smsLimit = 90;
      setTimeout(this.countDown, 1000);
    },
    countDown() {
      if (!this.smsLimit) {
        return;
      }
      this.smsLimit -= 1;
      setTimeout(this.countDown, 1000);
    },
  },
};
</script>
<style scoped>
.form-container {
  padding: 2% 5%;
}
</style>
